import { render, staticRenderFns } from "./tabsLine.vue?vue&type=template&id=8941a7a2&scoped=true"
import script from "./tabsLine.vue?vue&type=script&lang=js"
export * from "./tabsLine.vue?vue&type=script&lang=js"
import style0 from "./tabsLine.vue?vue&type=style&index=0&id=8941a7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8941a7a2",
  null
  
)

export default component.exports